<div class="daily-log-popup-container" [class.daily-log-popup-container--dark]="isDarkMode()">
  <div class="popup-header">
    <div class="title-with-icon">
      <mat-icon class="header-icon">cloud_upload</mat-icon>
      <h2>Master Logs Ingestion</h2>
    </div>
    <mat-icon class="close-btn" (click)="closeModal()">close</mat-icon>
  </div>

  <div class="tab-switcher">
    <button type="button" class="tab-btn" [class.active]="activeTab === 'daily_log'" (click)="setTab('daily_log')"
      [disabled]="isSubmitting">
      <mat-icon class="tab-icon">event_note</mat-icon>
      <span>Daily Temperature Reading</span>
    </button>
    <button type="button" class="tab-btn" [class.active]="activeTab === 'tank_profile'" (click)="setTab('tank_profile')"
      [disabled]="isSubmitting || tankProfileLocked"
      [attr.title]="tankProfileLocked ? 'Tank profile already exists for this voyage. Clear logs to upload a new one.' : null">
      <mat-icon class="tab-icon">{{ tankProfileLocked ? 'lock' : 'table_chart' }}</mat-icon>
      <span>Tank Profile</span>
    </button>
  </div>

  <div class="popup-body">
    <div class="upload-dropzone" (click)="uploadFile()" [class.is-disabled]="isSubmitting">
      <mat-icon class="upload-icon">upload_file</mat-icon>
      <div class="upload-text">
        <span class="upload-primary-text">
          {{ selectedFile ? 'Replace File' : 'Import File' }}
        </span>
        <span class="upload-secondary-text">Accepted formats (.xls, .xlsx)</span>
      </div>
    </div>

    <div *ngIf="selectedFile" class="file-name-badge">
      <mat-icon class="file-icon">description</mat-icon>
      <span class="name-text">{{ selectedFile.name }}</span>
    </div>

    <p *ngIf="vesselRulesLabel" class="vessel-rules-note">
      <mat-icon class="note-icon">info</mat-icon>
      <span>Vessel layout: {{ vesselRulesLabel }}</span>
    </p>

    <div class="safe-upsert-notice" *ngIf="activeTab === 'daily_log'">
      <mat-icon class="notice-icon">shield</mat-icon>
      <span>Upload daywise entries.</span>
    </div>

    <div class="safe-upsert-notice" *ngIf="tankProfileLocked">
      <mat-icon class="notice-icon">lock</mat-icon>
      <span>Tank profile is locked because this voyage already has logs. Clear logs to upload a new tank profile.</span>
    </div>

    <div class="safe-upsert-notice tank-profile-notice" *ngIf="activeTab === 'tank_profile'">
      <mat-icon class="notice-icon">inventory_2</mat-icon>
      <span>Upload the tank profile.</span>
    </div>
  </div>

  <div class="popup-actions">
    <button class="btn cancel-btn" type="button" (click)="closeModal()" [disabled]="isSubmitting">
      Cancel
    </button>
    <button class="btn submit-btn" type="button" (click)="executeInsert()" [disabled]="!canInsert">
      <mat-icon>{{ isSubmitting ? 'hourglass_top' : 'save_alt' }}</mat-icon>
      <span>{{ isSubmitting ? (activeTab === 'daily_log' ? 'Ingesting Logs...' : 'Ingesting Tank Profile...') :
        (activeTab ===
        'daily_log' ? 'Ingest Daily Logs' : 'Ingest Tank Profile') }}</span>
    </button>
  </div>
</div>